/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditoradddish3Inputs */

const en_menueditoradddish3 = /** @type {(inputs: Menueditoradddish3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a dish`)
};

const de_menueditoradddish3 = /** @type {(inputs: Menueditoradddish3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gericht hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add a dish" |
*
* @param {Menueditoradddish3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditoradddish3 = /** @type {((inputs?: Menueditoradddish3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditoradddish3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditoradddish3(inputs)
	return de_menueditoradddish3(inputs)
});
export { menueditoradddish3 as "menuEditorAddDish" }